const getters = {
  navbarid: state => state.user.navbarid,
  lang: state => state.user.lang,
  nav: state => state.user.nav,
  site_info: state => state.user.site_info,
  web_site: state => state.user.web_site
}
export default getters
